import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import { ToastContainer } from "react-toastify";
import { AuthenticationServiceProvider } from "../services/authentication.service";
import { ImpersonationProvider } from "../contexts/ImpersonationContext";
import { MasterLayout } from ".";
import { PrivateRoute } from "../components";
import roles from "../utils/constants/roles";

const Login = lazy(() => import("../pages/login"));
const NotFoundPage = lazy(() => import("../pages/error/not.found"));
const HomePage = lazy(() => import("../pages/home"));

export default function ProviderLayout() {
  return (
    <AuthenticationServiceProvider>
      <ImpersonationProvider>
      <ToastContainer />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <MasterLayout />
              </PrivateRoute>
            }
          >
            <Route
              index
              element={
                <PrivateRoute roles={roles.ALL_ROLES}>
                  <HomePage />
                </PrivateRoute>
              }
            />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
      </ImpersonationProvider>
    </AuthenticationServiceProvider>
  );
}
